/**
 * DEMO-ONLY: customer-owned warehouse held stock for Casey (MVP 2.6.3 LOCAL_MOCK).
 * Each SKU is held at a single Presidio warehouse with an exact quantity.
 */
import { PresidioWarehouseHeldItem } from '../../presidio-warehouse/models/presidio-warehouse-held-item.model';
import { isPresidioMockWarehouseLogin } from './presidio-mock-session';

const PRESIDIO_WAREHOUSE = {
  warehouseId: 'wh-presidio',
  warehouseName: 'Presidio Warehouse',
} as const;

/** Held SKUs for PRESIDIO-WH-MOCK — already purchased, stored at Presidio. */
export const PRESIDIO_MOCK_WAREHOUSE_HELD_INVENTORY: PresidioWarehouseHeldItem[] = [
  { sku: 'CISCO-C9300', availableQty: 12, ...PRESIDIO_WAREHOUSE },
  { sku: 'NV-L40S-48G', availableQty: 4, ...PRESIDIO_WAREHOUSE },
  { sku: 'PRS-WIFI-SW', availableQty: 48, ...PRESIDIO_WAREHOUSE },
  { sku: 'SUPPORT-3YR', availableQty: 6, ...PRESIDIO_WAREHOUSE },
  { sku: 'PRS-MOUSE-OPT', availableQty: 120, ...PRESIDIO_WAREHOUSE },
];

const bySku = new Map(PRESIDIO_MOCK_WAREHOUSE_HELD_INVENTORY.map(item => [item.sku, item]));

export function getPresidioWarehouseHeldInventory(): PresidioWarehouseHeldItem[] {
  return PRESIDIO_MOCK_WAREHOUSE_HELD_INVENTORY.map(item => ({ ...item }));
}

export function getPresidioWarehouseHeldItem(sku: string): PresidioWarehouseHeldItem | undefined {
  if (!sku) {
    return undefined;
  }
  const item = bySku.get(sku);
  return item ? { ...item } : undefined;
}

export function isPresidioWarehouseHeldSku(sku: string | undefined | null): boolean {
  return !!sku && bySku.has(sku);
}

/** True when the active demo login should treat held SKUs as $0 owned stock. */
export function isPresidioWarehouseHeldPricingActive(): boolean {
  return typeof sessionStorage !== 'undefined' && isPresidioMockWarehouseLogin();
}

/**
 * Unit price for basket/catalog when warehouse held pricing is active.
 * Returns 0 for held SKUs; otherwise undefined (caller uses catalog price).
 */
export function warehouseHeldUnitPriceOverride(sku: string): number | undefined {
  if (!isPresidioWarehouseHeldPricingActive()) {
    return undefined;
  }
  return isPresidioWarehouseHeldSku(sku) ? 0 : undefined;
}

export function maxWarehouseHeldAddQty(sku: string, requestedQty: number): number {
  const item = getPresidioWarehouseHeldItem(sku);
  if (!item) {
    return Math.max(1, Math.floor(requestedQty));
  }
  return Math.max(0, Math.min(item.availableQty, Math.floor(requestedQty)));
}
